export function taxQuery(filters, exportOnly = false) {
  const query = new URLSearchParams();
  const keys = exportOnly ? ['from', 'to', 'state'] :
    ['from', 'to', 'state', 'page', 'pageSize', 'sort', 'dir'];
  keys.forEach(key => {
    if (filters[key] !== '' && filters[key] != null) query.set(key, filters[key]);
  });
  return query.toString();
}

export function taxExportUrl(apiUrl, filters) {
  return `${apiUrl}/v1/seller/tax/export.csv?${taxQuery(filters, true)}`;
}

export function taxMoney(cents) {
  return `USD ${new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD',
  }).format((cents || 0) / 100)}`;
}

export async function downloadTaxCsv(authFetch, apiUrl, filters) {
  const response = await authFetch(taxExportUrl(apiUrl, filters));
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || body.message || 'Unable to export tax report. Please try again.');
  }
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `tax-center-${filters.from || 'all'}-${filters.to ||
    new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    // Give the browser time to start reading the object URL before releasing it.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  }
}
